import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect, Fragment } from "react"
import axios from "axios";
import '../../css/bootstrap.min.css'
import { schoolsurl, api, eligibility } from '../../apis/urls';
import Loader from "../../common-components/loader";
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";


const SchoolList =()=> { 

    const { id } = useParams();  

    let navigate = useNavigate();
    let token = "Bearer "+localStorage.getItem('token');
    //console.log(token)
    const [pagesize, setPagesize] = useState('50')

    let sizes = 50;

    let changePagesize = (e) => {

        //setPagesize(e.target.value)
        sizes = e.target.value;
        Listing(sizes);
        setPageCount(sizes)      
        

    }
    
    const instance = axios.create({
        baseURL: schoolsurl+'?page='+0+'&size='+sizes,
        timeout: 1000000,
        headers: {'authorization': token}
      });

      

// list

    useEffect(() => {
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        $('html,body').animate({ scrollTop: 0 }, 'fast');

        let store = localStorage.getItem('token');
        // console.log('listing',store)
        // if(store){
        //     Listing();
        // }else{      
        //     navigate("/")
        // }
    setTimeout(() => {
        Listing(50);
        });   

    },[]);


const [pageCount, setPageCount] = useState("50")
const [loader,setLoader] = useState(false);
const [linkList, setLinkList] = useState([]);
const [currentpage, setCurrentpage] = useState([]);
const [totalPages, setTotalPages] = useState([]);
const [totalItems, setTotalItems] = useState([]);
const [searchTitle, setSearchTitle] = useState("");
const [athleticResult, setAthleticResult] = useState("");
const [emailExist, setEmailExist] = useState("")

const Listing = ((sizeCount) => {

    const instances = axios.create({
        baseURL: schoolsurl+'?page='+0+'&size='+sizeCount,
        timeout: 1000000,
        headers: {'authorization': token}
      });



    console.log('true',loader)
    instances.get('').then(res => {

    if(res.data.message === "Success"){               
    setLinkList(res.data.data.dataItems);
    setCurrentpage(res.data.data.currentPage)
    setTotalPages(res.data.data.totalPages)
    setTotalItems(res.data.data.totalItems)
    }else{
        setLinkList(false)
    }


    console.log('result',res.data.data)
    
    
        setLoader(false);
    }).catch(e => {
    // console.log('errorshw',e);
    // if()
    localStorage.removeItem('token')
    
    navigate("/")
    });
});


// delete
    const URI = schoolsurl
    const removeAccreditations = (id) => {
        let r = window.confirm("Are you sure you want to delete this School?");
        if(r == true){
        try {

            instance.delete(`${URI}/${id}`).then((response) =>{
                Listing();
                //navigate("/school_list")
        
            })
            
        } catch (error) {
          alert(error)
          console.log(error)
        }
      }
    }


    const refreshList = () => {
        setLinkList(null);
    };


    const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    const findByTitles = name => {
        return instances.get(`schools?search=${name}`);
    };

    const onChangeSearchTitle = (e) => {
        const searchTitle = e.target.value;
        setSearchTitle(searchTitle);
        findByTitles(searchTitle)
          .then(response => {
            
            if(response.data.message=== "Success"){
                setLinkList(response.data.data.dataItems);
            }else{
                setLinkList(false)
            }
          })
          .catch(e => {
            console.log(e);
          });
    };

    const findByTitlesss = option => {
        return instances.get(`schools?status=${option}`);
    };

    const onChangeSearchTitles = (e) => {
        const searchTitle = e.target.value;
        findByTitlesss(searchTitle)
          .then(response => {
            if(response.data.message=== "Success"){
                setLinkList(response.data.data.dataItems);
            }else{
                setLinkList(false)
            }
          })
          .catch(e => {
            console.log(e);
          });
    };

    //PAGINATION


     // Invoke when user click to request another page.
    const handlePageClick = (event) => { console.log('EVENTSSS',event)

        const instance = axios.create({
            baseURL: schoolsurl+'?page='+event.selected+'&size='+pageCount,
            timeout: 1000000,
            headers: {'authorization': token}
          });

          

        instance.get('').then(res => {

            setLinkList(res.data.data.dataItems)
        
            setLoader(false);
        }).catch(e => {
        //console.log('errorshw',e);
        localStorage.removeItem('token')
        navigate("/")
        });


    }; 


    return(
        <div>
        <aside class="right-side areas">    
			<div class="content-area dash-contentss">
                          <div class="page-title-wrpr">
                <div class="page-title-left-column">
                    <i class="icon-library1"></i>
                    <h2 class="page-title"> School List</h2>
                </div>

                



                <div className="page-rightside-action-column">

                
                <div className="input-group mt-3 mb-3 search-grp">
                        <div className="input-group-prepends">
                        <select className="form-controls custom-select" onChange={onChangeSearchTitles}>
                                <option value="none" selected disabled hidden>STATUS</option>
                                <option value=" ">ALL</option>
                                <option>ACTIVE</option>
                                <option>INACTIVE</option>
                                <option>DELETE</option>
                            </select> 
                        </div>
                        <input type="text" 
                        className="form-controls search-bar"             
                        value={searchTitle}
                        onChange={onChangeSearchTitle}
                        placeholder="Search" />
                        
                        <button className="btn btn-search icon-search"></button>
                </div>

               



                <Link to="/add_schools" data-toggle="tooltip" title="" className="addbtnitem-link text-anchor" data-original-title="Add New School"><i className="icon-add"></i><span>Add New School</span> </Link>



                </div>
            </div>


             
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">School List</li>
              </ol>
            </nav>
            <div className="row">
            {
                linkList?
                (
                    <Fragment>
                    <div className="number-of col-md-4">
                        Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ linkList?.length} of {totalItems} results.
                    </div>

                    <div className="col-md-6"></div>
                    <div className="col-md-2 input-group">
                        <select className="form-control bg-light dark-theme showtext" onChange={ changePagesize } id="status-selector">
                            <option value="50">Select pages</option>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    </Fragment>
                ):null
            }
                
               
                </div>

                {loader?
                        <div className="container">
                               <div className="loader_container"><Loader/></div>
                        </div>:null
                }
                
            
            <div className="faculty-list-wrpr list-wrpr">
                    {linkList?(
                    
            linkList?.map((linkvalue, index) =>
                <div key={index} className="list faculty">
                    <div className="row">
                        <div className="col-md-1">
                            <div className="update-date">
                                <span className="date-wrpr">{(index+1)+currentpage*10}</span>
                                <span className="desig">Sl.No</span>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="update-date">
                                <span className="date-wrpr">{decode(linkvalue.name)}</span>
                                <span className="desig">School Name</span>            
                            </div>
                        </div>
                        

                        <div className="col-md-2">
                            <div className="update-date">
                                <span className="date-wrpr">{linkvalue.phone}</span>
                                <span className="desig">School Phone</span>            
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="list-action-wrpr list-action-wrprs text-right roundicons-text">

                                <Link  to={"/school_list/coach/"+linkvalue.id} data-toggle="Coach" title="Coach">
                                        <i className="icon-baseball"></i>
										<span>Coaches</span>
                                </Link>


                                <Link  to={"/school_list/faculty/"+linkvalue.id}  data-toggle="Admin/Staff" title="Admin/Staff">
                                        <i className="sports icon-custom-image"></i>
										<span>Admin/Staff</span>
                                </Link>
                                <Link  to={"/members/"+linkvalue.id} data-toggle="staff" title="Staff/Members">
                                        <i class="staffMembers icon-users1"></i>
										<span>Permissions</span>
                                </Link>
                                <Link  to={"/jobs/"+linkvalue.id} data-toggle="Jobs" title="Jobs">
                                    <i data-count={linkvalue.JobCount} className="jobs icon-suitcase1 data-counts-icon"></i>
                                    <span>Jobs</span>
                                </Link>
                                <Link  to={"/school_list/athlet_list/"+linkvalue.id} data-toggle="Athlet" title="Athletic Eligibility">
                                    <i  data-count={linkvalue.athletCount}  className="athleticElig icon-custom-image data-counts-icon"></i>
                                    <span>Athletic Eligibility</span>
                                </Link>
                                
                                <Link  to={"/school_profile/"+linkvalue.id} data-toggle="School Profile" title="School Profile">
                                    <i className="jobs icon-eye"></i>
                                    <span>View</span>
                                </Link>
                                
                            </div>
                        </div>
                    </div>                   
                </div>
                )):null}
               
                
                {
                !linkList?
                (<div className="nodata">
                    <h2>Sorry! No Schools Found</h2>
                </div>):null
                }

                {
                    linkList?
                    (
                        <div className="number-of footer-number">
                            Displaying {(currentpage*10 )+ 1}-{(currentpage*10 )+ linkList?.length} of {totalItems} results.
                        </div>
                    ):null
                }
                {linkList?
                <div className="pagination-wrpr">
                    <ReactPaginate
                            className="pagination page"
                            pageClassName="page-item"
                            activeClassName="active"
                            nextLabel=">"
                            previousLabel="<"
                            previousClassName="page-link p-link"
                            nextClassName="page-link p-link"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={10}
                            pageCount={totalPages}
                            renderOnZeroPageCount={1}
                        />
                </div>:null 
                }
                
                 

               
            </div>         
        </div>
      </aside>

    </div>
    );
}

export default SchoolList;
